import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter, Inject, LOCALE_ID, ChangeDetectorRef } from '@angular/core';
import * as dateFns from 'date-fns';

import { CalendarEvent } from '../../utils/CalendarEvent';
import { Calendar } from '../../utils/Calendar';

import { WeekDay } from '../../utils/week-day';
import { MonthViewDay } from '../../utils/month/MonthViewDay';
import { CalendarEventTimesChangedEvent } from '../../utils/CalendarEventTimesChangedEvent';
import { MonthView } from '../../utils/month/MonthView';
import { CalendarUtilsService } from './../../utils/calendar-utils.service';
import { validateEvents } from './../../utils/isInside';

import { MonthViewEvent } from '../../utils/month/MonthViewEvent';

import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
export class MonthViewComponent implements OnInit, OnChanges, OnDestroy {
/**
 * The current view date
 */
viewDate: Date;
/**
 * An array of events to display on view.
 */
events: CalendarEvent[] = [];
/**
 * An array of calendars to display on view.
 */
calendars: Calendar[] = [];
/**
 * An array of day indexes (0 = sunday, 1 = monday etc) that will be hidden on the view
 */
excludeDays: number[] = [];
/**
 * Whether the events list for the day of the `viewDate` option is visible or not
 */
activeDayIsOpen = false;
/**
 * An observable that when emitted on will re-render the current view
 */
refresh: Subject<any>;
/**
 * The locale used to format dates
 */
locale: string;
/**
 * The start number of the week
 */
weekStartsOn: number;
/**
 * An array of day indexes (0 = sunday, 1 = monday etc) that indicate which days are weekends
 */
weekendDays: number[];

  event: CalendarEvent;
/**
 * An output that will be called before the view is rendered for the current month.
 * If you add the `cssClass` property to a day in the body it will add that class to the cell element in the template
 */
beforeViewRender: EventEmitter<{
    header: WeekDay[];
    body: MonthViewDay[];
  }> = new EventEmitter();
/**
 * Called when the event title is clicked
 */
eventClicked: EventEmitter<{ event: CalendarEvent }> = new EventEmitter<{
    event: CalendarEvent;
  }>();
/**
 * Called when a new event is created by clicking on a month cell
 */
addEventMonthCellClicked: EventEmitter<{ event: CalendarEvent, isEventClicked: boolean }> = new EventEmitter<{
    event: CalendarEvent;
    isEventClicked: boolean;
  }>();
/**
 * Called when the new event is extended
 */
newEventTimesChanged: EventEmitter<{ event: CalendarEvent, end: boolean, isEventClicked: boolean }> = new EventEmitter<{
    event: CalendarEvent;
    end: boolean,
    isEventClicked: boolean
  }>();
/**
 * Called when the new event is extended
 */
newEventTimesChangedEnd: EventEmitter<{ event: CalendarEvent }> = new EventEmitter<{
    event: CalendarEvent;
  }>();
/**
 * Called when an event is dragged and dropped
 */
eventTimesChanged: EventEmitter<
    CalendarEventTimesChangedEvent
    > = new EventEmitter<CalendarEventTimesChangedEvent>();
/**
 * @hidden
 */
columnHeaders: any;
/**
 * @hidden
 */
view: any;
/**
 * @hidden
 */
monthEvents: MonthViewEvent[];
/**
 * @hidden
 */
openRowIndex: any;
/**
 * @hidden
 */
openDay: any;
/**
 * @hidden
 */
refreshSubscription: Subscription;

  isEventClicked = false;
/**
 * @hidden
 * @param {?} cdr
 * @param {?} utils
 * @param {?} locale
 */
constructor(
private cdr: ChangeDetectorRef,
private utils: CalendarUtilsService,
     locale: string
  ) {
    this.locale = locale;
  }
/**
 * @return {?}
 */
ngOnInit() {
    if (this.refresh) {
      this.refreshSubscription = this.refresh.subscribe(() => {
        this.refreshAll();
        this.cdr.markForCheck();
      });
    }
  }
/**
 * @hidden
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: any): void {
    if (changes.viewDate || changes.excludeDays || changes.weekendDays) {
      this.refreshHeader();
    }

    if (changes.events) {
      validateEvents(this.events);
    }

    if (changes.calendars) {
      for (const /** @type {?} */ calendar of this.calendars) {
        validateEvents(calendar.events);
        this.refreshBody();
      }
    }

    if (
      changes.viewDate ||
      changes.events ||
      changes.calendars ||
      changes.excludeDays ||
      changes.weekendDays
    ) {
      this.refreshBody();
    }

    if (
      changes.activeDayIsOpen ||
      changes.viewDate ||
      changes.events ||
      changes.excludeDays
    ) {
      this.checkActiveDayIsOpen();
    }
  }
/**
 * @hidden
 * @return {?}
 */
ngOnDestroy(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }
/**
 * @return {?}
 */
private refreshHeader(): void {
    this.columnHeaders = this.utils.getWeekViewHeader({
      viewDate: this.viewDate,
      weekStartsOn: this.weekStartsOn,
      excluded: this.excludeDays,
      weekendDays: this.weekendDays
    });
    this.emitBeforeViewRender();
  }
/**
 * @return {?}
 */
private refreshBody(): void {
    this.view = this.utils.getMonthViewGrid({
      events: this.events,
      calendars: this.calendars,
      viewDate: this.viewDate,
      weekStartsOn: this.weekStartsOn,
      excluded: this.excludeDays,
      weekendDays: this.weekendDays
    });
    this.emitBeforeViewRender();
  }
/**
 * @return {?}
 */
private emitBeforeViewRender(): void {
    if (this.columnHeaders && this.view) {
      this.beforeViewRender.emit({
        header: this.columnHeaders,
        body: this.view.days
      });
    }
  }
/**
 * @return {?}
 */
private checkActiveDayIsOpen(): void {
    if (this.activeDayIsOpen === true) {
      this.openDay = this.view.days.find((day: any) =>
        dateFns.isSameDay(day.date, this.viewDate)
      );
      const /** @type {?} */ index: number = this.view.days.indexOf(this.openDay);
      this.openRowIndex =
        Math.floor(index / this.view.totalDaysVisibleInWeek) *
        this.view.totalDaysVisibleInWeek;
    } else {
      this.openRowIndex = null;
      this.openDay = null;
    }
  }
/**
 * @return {?}
 */
private refreshAll(): void {
    this.columnHeaders = null;
    this.view = null;
    this.refreshHeader();
    this.refreshBody();
    this.checkActiveDayIsOpen();
  }
/**
 * @hidden
 * @param {?} day
 * @param {?} event
 * @return {?}
 */
eventDropped(day: MonthViewDay, event: CalendarEvent): void {
    const /** @type {?} */ year: number = dateFns.getYear(day.date);
    const /** @type {?} */ month: number = dateFns.getMonth(day.date);
    const /** @type {?} */ date: number = dateFns.getDate(day.date);
    const /** @type {?} */ newStart: Date = dateFns.setDate(
      dateFns.setMonth(dateFns.setYear(event.start, year), month),
      date
    );
    let /** @type {?} */ newEnd: Date;
    if (event.end) {
      const /** @type {?} */ secondsDiff: number = dateFns.differenceInSeconds(newStart, event.start);
      newEnd = dateFns.addSeconds(event.end, secondsDiff);
    }
    this.eventTimesChanged.emit({ event, newStart, newEnd });
  }
/**
 * @param {?} $event
 * @param {?} event
 * @return {?}
 */
monthCellClicked($event, event) {
    this.addEventMonthCellClicked.emit({ event: event, isEventClicked: false });
  }
/**
 * @param {?} $event
 * @param {?} event
 * @return {?}
 */
monthEventClicked($event: MouseEvent, event: CalendarEvent) {
    this.eventClicked.emit({ event: event });
  }
/**
 * @param {?} $event
 * @return {?}
 */
mouseUpEvent($event: Event) {
    this.event = null;
    this.newEventTimesChanged.emit({ event: this.event, end: true, isEventClicked: this.isEventClicked });
    this.isEventClicked = false;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-month-view',
  template: `
    <div class="cal-month-view">
        <calendar-month-view-header
          [days]="columnHeaders"
          [locale]="locale">
        </calendar-month-view-header>
        <div class="cal-days" (mouseup)="mouseUpEvent($event)">
            <div class="cal-row" *ngFor="let rowIndex of view.rowOffsets; let index = index">
              <div *ngIf="rowIndex" class="cal-cell-row">
                <div
                class="cal-day-cell"
                *ngFor="let day of rowIndex.days"
                (mousemove)="$event.preventDefault();newEventTimesChanged.emit({event: event, end: false, isEventClicked: false});">
                  <calendar-month-cell
                    class="calendar-month-cell"
                    (mousedown)="monthCellClicked($event, event)" 
                    [class.cal-drag-over]="day.dragOver"
                    [ngClass]="{'isToday': day.isToday }"
                    [day]="day"
                    [event]="event"
                    (updateEvent)="event = $event.event;"
                    (newEvent)="event = $event.event;"
                    [openDay]="openDay"
                    [locale]="locale"
                    appMonthCellDrag 
                    dropDirective 
                    (dragenterEvent)="isEventClicked = false;"
                    (dropEvent)="eventDropped(day, $event)">
                  </calendar-month-cell>
                </div>
                <div *ngFor="let event of rowIndex.events">
                    <div
                    *ngIf="!event.hidden && event.event.draggable"
                    [class.month-event]="event.event.allDay"
                    [class.month-non-all-day-event]="!event.event.allDay"
                    [style.height]="20 + '%'"
                    [style.top]="event.top + '%'"
                    [style.backgroundColor]="event.event.color ? event.event.color : event.event.calendar.color"
                    [style.left]="event.left + '%'"
                    [style.width]="event.event.allDay ? event.width + '%' : 100/7 +'%'"
                    (mousedown)="isEventClicked = true;"
                    (click)="monthEventClicked($event, event.event)"
                    [dragDirective]='event.event'
                    [dragHightlight]="'highlight'">
                    <div
                      *ngIf="!event.event.allDay"
                      class="month-non-all-day-event-color"
                      [style.backgroundColor]="event.event.color ? event.event.color : event.event.calendar.color">
                    </div>
                    <div class="month-event-title">
                        {{ event.event.start | date : 'hh:mm a'}} {{ event.event.title }}
                    </div>
                    </div>
                    <div
                    *ngIf="!event.hidden && !event.event.draggable"
                    [class.month-event]="event.event.allDay"
                    [class.month-non-all-day-event]="!event.event.allDay"
                    [style.height]="20 + '%'"
                    [style.top]="event.top + '%'"
                    [style.backgroundColor]="event.event.color ? event.event.color : event.event.calendar.color"
                    [style.left]="event.left + '%'"
                    [style.width]="event.event.allDay ? event.width + '%' : 100/7 +'%'"
                    (mousedown)="isEventClicked = true;"
                    (click)="monthEventClicked($event, event.event)">
                    <div
                      *ngIf="!event.event.allDay"
                      class="month-non-all-day-event-color"
                      [style.backgroundColor]="event.event.color ? event.event.color : event.event.calendar.color">
                    </div>
                    <div class="month-event-title">
                        {{ event.event.start | date : 'hh:mm a'}} {{ event.event.title }}
                    </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
    </div>
  
  `,
  styles: [`
    .cal-month-view {
      overflow: hidden;
      background-color: white; }

    .cal-days {
      border: 1px solid #EBEEF2;
      border-bottom: 0;
      position: relative; }

    .month-events-of-week {
      -webkit-box-flex: 1;
          -ms-flex: 1;
              flex: 1; }

    .cal-row {
      position: relative; }

    .month-event {
      position: absolute;
      color: white;
      padding-left: 5px;
      padding-right: 5px;
      font-size: 12px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
      cursor: pointer;
      overflow: hidden;
      -webkit-box-shadow: 0 3px 2px rgba(0, 0, 0, 0.3);
              box-shadow: 0 3px 2px rgba(0, 0, 0, 0.3);
      z-index: 11; }

    .month-event-title {
      white-space: nowrap;
      text-overflow: ellipsis;
      -webkit-box-flex: 1;
          -ms-flex: 1;
              flex: 1;
      overflow: hidden; }

    .cal-cell-row:hover {
      background-color: #fafafa; }

    .cal-cell-row .cal-cell:hover,
    .cal-cell.cal-has-events.cal-open {
      background-color: #ededed; }

    .cal-cell-row {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      height: 18vh; }

    @media (max-height: 500px) {
      .cal-cell-row {
        height: 25vh; } }

    .cal-cell {
      width: 100%; }

    .cal-day-cell {
      height: 100%;
      width: 14.28571%;
      position: relative; }

    .calendar-month-cell {
      width: 100% !important;
      height: 100%;
      position: relative; }

    .cal-day-cell:not(:last-child) {
      border-right: 1px solid #EBEEF2; }

    .cal-weekend:not(:first-child) {
      border-right: none !important; }

    .cal-days .cal-cell-row {
      border-bottom: 1px solid #EBEEF2; }

    @media (max-width: 576px) {
      .cal-day-cell:not(:last-child) {
        border-right: none !important; }
      .cal-days .cal-cell-row {
        border-bottom: none !important; }
      .cal-days .cal-cell-row:last-child {
        border-bottom: 1px solid #EBEEF2 !important; } }

    .isToday {
      background-color: #fafafa; }

    .month-non-all-day-event {
      position: absolute;
      background-color: transparent !important;
      color: #555555;
      padding-left: 5px;
      padding-right: 5px;
      font-size: 12px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
      cursor: pointer;
      overflow: hidden;
      z-index: 10; }

    .month-non-all-day-event-color {
      height: 10px;
      width: 10px;
      border-radius: 50%;
      margin-left: 5px;
      margin-right: 5px; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: CalendarUtilsService, },
{type: undefined, decorators: [{ type: Inject, args: [LOCALE_ID, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'viewDate': [{ type: Input },],
'events': [{ type: Input },],
'calendars': [{ type: Input },],
'excludeDays': [{ type: Input },],
'activeDayIsOpen': [{ type: Input },],
'refresh': [{ type: Input },],
'locale': [{ type: Input },],
'weekStartsOn': [{ type: Input },],
'weekendDays': [{ type: Input },],
'beforeViewRender': [{ type: Output },],
'eventClicked': [{ type: Output },],
'addEventMonthCellClicked': [{ type: Output },],
'newEventTimesChanged': [{ type: Output },],
'newEventTimesChangedEnd': [{ type: Output },],
'eventTimesChanged': [{ type: Output },],
};
}

function MonthViewComponent_tsickle_Closure_declarations() {
/** @type {?} */
MonthViewComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MonthViewComponent.ctorParameters;
/** @type {?} */
MonthViewComponent.propDecorators;
/**
 * The current view date
 * @type {?}
 */
MonthViewComponent.prototype.viewDate;
/**
 * An array of events to display on view.
 * @type {?}
 */
MonthViewComponent.prototype.events;
/**
 * An array of calendars to display on view.
 * @type {?}
 */
MonthViewComponent.prototype.calendars;
/**
 * An array of day indexes (0 = sunday, 1 = monday etc) that will be hidden on the view
 * @type {?}
 */
MonthViewComponent.prototype.excludeDays;
/**
 * Whether the events list for the day of the `viewDate` option is visible or not
 * @type {?}
 */
MonthViewComponent.prototype.activeDayIsOpen;
/**
 * An observable that when emitted on will re-render the current view
 * @type {?}
 */
MonthViewComponent.prototype.refresh;
/**
 * The locale used to format dates
 * @type {?}
 */
MonthViewComponent.prototype.locale;
/**
 * The start number of the week
 * @type {?}
 */
MonthViewComponent.prototype.weekStartsOn;
/**
 * An array of day indexes (0 = sunday, 1 = monday etc) that indicate which days are weekends
 * @type {?}
 */
MonthViewComponent.prototype.weekendDays;
/** @type {?} */
MonthViewComponent.prototype.event;
/**
 * An output that will be called before the view is rendered for the current month.
 * If you add the `cssClass` property to a day in the body it will add that class to the cell element in the template
 * @type {?}
 */
MonthViewComponent.prototype.beforeViewRender;
/**
 * Called when the event title is clicked
 * @type {?}
 */
MonthViewComponent.prototype.eventClicked;
/**
 * Called when a new event is created by clicking on a month cell
 * @type {?}
 */
MonthViewComponent.prototype.addEventMonthCellClicked;
/**
 * Called when the new event is extended
 * @type {?}
 */
MonthViewComponent.prototype.newEventTimesChanged;
/**
 * Called when the new event is extended
 * @type {?}
 */
MonthViewComponent.prototype.newEventTimesChangedEnd;
/**
 * Called when an event is dragged and dropped
 * @type {?}
 */
MonthViewComponent.prototype.eventTimesChanged;
/**
 * @hidden
 * @type {?}
 */
MonthViewComponent.prototype.columnHeaders;
/**
 * @hidden
 * @type {?}
 */
MonthViewComponent.prototype.view;
/**
 * @hidden
 * @type {?}
 */
MonthViewComponent.prototype.monthEvents;
/**
 * @hidden
 * @type {?}
 */
MonthViewComponent.prototype.openRowIndex;
/**
 * @hidden
 * @type {?}
 */
MonthViewComponent.prototype.openDay;
/**
 * @hidden
 * @type {?}
 */
MonthViewComponent.prototype.refreshSubscription;
/** @type {?} */
MonthViewComponent.prototype.isEventClicked;
/** @type {?} */
MonthViewComponent.prototype.cdr;
/** @type {?} */
MonthViewComponent.prototype.utils;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
